<template>
	<div v-if="errors">
		<ul v-for="error in errors" v-if="errors.length>1" class="alert alert-danger">
			<li>
				{{error}}
			</li>
		</ul>
		<div v-else class="text-danger">
			{{error}}
		</div>
	</div>
</template>
<script>
	export default{
		props: ['errors'],
	}
</script>